import {
  IconButton,
  List,
  ListItem,
  ListItemText,
  Popover,
  Tooltip,
} from "@mui/material";
import { useHotkeyRegistrations } from "@tanstack/react-hotkeys";
import { useState } from "react";
import { Kbd } from "./kbd";

const HotkeyPalette: React.FC = () => {
  const { hotkeys } = useHotkeyRegistrations();

  return (
    <List dense disablePadding sx={{ width: 300, p: 2 }}>
      {hotkeys.map((reg) => (
        <ListItem key={reg.id} disablePadding>
          <ListItemText
            primary={
              <>
                <Kbd>{reg.hotkey}</Kbd> {reg.options.meta?.name}
              </>
            }
            secondary={reg.options.meta?.description}
          />
        </ListItem>
      ))}
    </List>
  );
};

export const HotkeyPaletteIcon: React.FC = () => {
  const [showPalette, setShowPalette] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const togglePalette = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setShowPalette((prev) => !prev);
  };

  return (
    <>
      <Tooltip title="Visa kortkommandon" placement="bottom">
        <IconButton onClick={togglePalette} sx={{ cursor: "pointer" }}>
          <Kbd>?</Kbd>
        </IconButton>
      </Tooltip>
      <Popover
        open={showPalette}
        onClose={togglePalette}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <HotkeyPalette />
      </Popover>
    </>
  );
};
